export class UpdateProfileFeatures
{
    static IdentifierUpdateUsername = "UpdateUserName";
    //static IdentifierUpdateEmail = "updateemail";
    static IdentifierUpdateCategories = "UpdateCategories";
    static IdentifierUpdateProfilePic = "UpdateProfilePic";

    static ServTypeUpdateUsername = "UPDATE_USER_NAME";
    //static ServTypeUpdateEmail = "UPDATE_EMAIL"; 
    static ServTypeUpdateCategories = "UPDATE_CATAGORIES";
    static ServTypeUpdateProfilepic = "UPDATE_PROFILE_PIC";
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/updateprofilefeatures.tsx